<template>
    <BRow class="candidate-list-safety-instructions">
        <BCol cols="12" md="6" class="mb-1 mb-md-0">
            <BCard no-body class="h-100 mb-0">
                <div class="card-header">
                    <h6 class="mb-0">
                        {{ $t('Component(Verification):safe-use-label') }}
                    </h6>
                </div>
                <div class="card-body">
                    <BFormCheckbox
                        :checked="identificationIsSufficient"
                        @input="changeIdentificationSufficiency"
                    >
                        {{ $t('Component(Text):safe-use-applicability') }}
                    </BFormCheckbox>
                    <BFormGroup
                        v-if="!identificationIsSufficient"
                        class="mt-1 mb-0"
                        :label="$t('Component(Label):safe-use-instructions')"
                    >
                        <BFormTextarea
                            :value="instructions.safeUseDescription"
                            :placeholder="$t('Component(Placeholder):type-here')"
                            rows="3"
                            max-rows="8"
                            @input="changeSafeUseInstructions"
                        />
                    </BFormGroup>
                </div>
            </BCard>
        </BCol>
        <BCol cols="12" md="6">
            <BCard no-body class="h-100 mb-0">
                <div class="card-header">
                    <h6 class="mb-0">
                        {{ $t('Component(Verification):dissembling-label') }}
                    </h6>
                </div>
                <div class="card-body">
                    <BFormGroup
                        class="mb-0"
                        :label="$t('Component(Label):dissembling-instructions')"
                    >
                        <BFormTextarea
                            :value="instructions.disassemblingDescription"
                            :placeholder="$t('Component(Placeholder):type-here')"
                            rows="3"
                            max-rows="8"
                            @input="changeDisassemblingInstructions"
                        />
                    </BFormGroup>
                </div>
            </BCard>
        </BCol>
    </BRow>
</template>

<script>
import {
    BCard,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormTextarea,
    BRow,
} from 'bootstrap-vue'

export default {
    name: 'CandidateListSafetyInstructions',
    components: {
        BCard,
        BCol,
        BFormCheckbox,
        BFormGroup,
        BFormTextarea,
        BRow,
    },
    props: {
        instructions: { type: Object, required: true },
    },
    computed: {
        identificationIsSufficient() {
            return this.instructions.isSafeUseApplicable !== true
        },
    },
    mounted() {
        if (this.instructions.isSafeUseApplicable === null) {
            this.changeIdentificationSufficiency(true)
        }
    },
    methods: {
        changeIdentificationSufficiency(isSufficient) {
            this.$emit('action', {
                type: 'safe-use-applicability.change',
                payload: { value: !isSufficient },
            })
        },
        changeSafeUseInstructions(value) {
            this.$emit('action', {
                type: 'safe-use-instructions.change',
                payload: { value },
            })
        },
        changeDisassemblingInstructions(value) {
            this.$emit('action', {
                type: 'disassembling-instructions.change',
                payload: { value },
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.candidate-list-safety-instructions {
    margin-top: 1.25rem;

    .card-header {
        border-bottom: 1px solid #ebe9f1;
        padding: 1rem 1.25rem;
    }

    .card-body {
        padding: 1.25rem;
    }
}
</style>
